///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportLocationGroup = Meevo.Plugins.Reports.IReportLocationGroup;

    export class ReportLocationGroupsCollection extends SmartMoverApiCollection<IReportLocationGroup> implements IApiCollection<IReportLocationGroup> {

        protected get url() {
            return 'report/LocationGroup';
        }

        constructor(connectedModel: ModelValueType[], items: IReportLocationGroup[] = [], options: ICollectionOptions<IReportLocationGroup> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                businessTypeList: [],
                includeActive: true,
                includeAllLocationsListItem: false,
                includeDeleted: false,
                includeInactive: false
            });
        }
    }

}
